
import { TierDTO, TierVariantVm, TierVM } from "../models/settings/tier.model";

export class SettingMapper {
  public static tierVM(tier: TierDTO): TierVM {
    return new TierVM({
      createdBy: '',
      createdOn: '',
      description: tier.description,
      id: tier.id,
      name: tier.name,
      variant: new TierVariantVm(),
      storeChannelId: tier.storeChannelId,
      isArchived: tier.isArchived,
      includeVariantsWithoutTiers: tier.includeVariantsWithoutTiers
    });
  }
}
